import { render } from "./PreviewCard.vue?vue&type=template&id=27d134cb"
import script from "./PreviewCard.vue?vue&type=script&lang=js"
export * from "./PreviewCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__